import React, {Component} from 'react';
import {Link} from 'react-router-dom';

// Elements
import AboutSection from "../elements/about";
import LatestNewsSection from "../elements/latest-news-slider";
import FeatureSection3 from "../elements/feature-section3";
import TeamSection from "../elements/team";
import TestimonialSection from "../elements/testimonial";

// Import Images
import bnrImg1 from "../../images/banner/img1.jpg";
import waveBlue from "../../images/shap/wave-blue.png";
import circleDots from "../../images/shap/circle-dots.png";
import plusBlue from "../../images/shap/plus-blue.png";

class AboutUs extends Component{
	
	render(){
		return (
			<>
				
				<div className="page-content bg-white">
					
					<div className="banner-wraper">
						<div className="page-banner" style={{backgroundImage: "url("+bnrImg1+")"}}>
							<div className="container">
								<div className="page-banner-entry text-center">
									<h1>Utopia Dental Clinic</h1>
									<nav aria-label="breadcrumb" className="breadcrumb-row">
										<ul className="breadcrumb">
											<li className="breadcrumb-item"><Link to="/"><svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="feather feather-home"><path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"></path><polyline points="9 22 9 12 15 12 15 22"></polyline></svg> Home</Link></li>
											<li className="breadcrumb-item active" aria-current="page">Nosotros</li>
										</ul>
									</nav>
								</div>
							</div>
							<img className="pt-img1 animate-wave" src={waveBlue} alt=""/>
							<img className="pt-img2 animate2" src={circleDots} alt=""/>
							<img className="pt-img3 animate-rotate" src={plusBlue} alt=""/>
						</div>
					</div>
					
					<div className="container">
						<div className="row">
							<div className="col-lg-12">
								<p className=" m-b30">
									En Utopia Dental Clinic, nuestra misión es cuidar de tu sonrisa con un enfoque integral y personalizado. Nos dedicamos a ofrecer atención dental de alta calidad, priorizando la salud y el bienestar de nuestros pacientes. Nuestro equipo de profesionales altamente capacitados está comprometido a brindarte un servicio excepcional en un ambiente acogedor y amigable.</p>

								<p>Empezamos como profesionales independientes y hoy tenemos nuestro propio espacio donde te ofrecemos una atención destacada, no somos una clinica más, somos el esfuerzo de un equipo que se integro para cuidarte.</p>

								<p>Desde nuestro consul en el barrio de Villa Crespo, estamos para ti.</p>
							</div>
						</div>

					</div>
					<FeatureSection3 />
					
					<TeamSection />
					
					<TestimonialSection />
					
				
				</div>
				
			</>
		);
	}
}

export default AboutUs;